module.exports = __webpack_public_path__ + "static/media/NightStand_Before.609b3431.jpg";